import { NormalizedCacheObject } from 'apollo-boost';

import { ServerMarketerAccess } from '../typings/marketers';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class MarketersDataProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(apiManager: RestApiManager, client: DNAApolloClient<NormalizedCacheObject>) {
        super(client);
        this.apiManager = apiManager;
    }

    public getList() {
        return this.apiManager.getInternalMarketers();
    }

    public getMarketer(id: string) {
        return this.apiManager.getInternalMarketer(id);
    }

    public async addProductAccess(
        marketerId: string,
        productId: string,
        accessType: ServerMarketerAccess,
        placeIds: number[] = []
    ) {
        return this.apiManager.addInternalMarketerProductAccess(marketerId, productId, accessType, placeIds);
    }

    public updateProductAccess(
        marketerId: string,
        productId: string,
        accessType: ServerMarketerAccess,
        placeIds: number[] = []
    ) {
        return this.apiManager.updateInternalMarketerProductAccess(marketerId, productId, accessType, placeIds);
    }

    public removeProductAccess(marketerId: string, productId: string) {
        return this.apiManager.removeInternalMarketerProductAccess(marketerId, productId);
    }
}
